import { Link } from 'react-router-dom';

interface AuthFrameProps {
  kicker: string;
  title: string;
  children: React.ReactNode;
}

/**
 * Shared shell for the sign-in, register and password pages: rule-lined
 * header with the wordmark, then a left-rail column at the tight measure.
 */
export default function AuthFrame({ kicker, title, children }: AuthFrameProps) {
  return (
    <main className="min-h-screen bg-canvas text-ink">
      <header className="flex items-center justify-between h-12 px-4 lg:px-12 border-b border-edge">
        <Link to="/" className="wordmark text-xl">
          ou<em>r</em>ss
        </Link>
        <span className="kicker">Self-hosted · RSS</span>
      </header>

      <section className="px-4 lg:px-12 py-10 lg:py-16">
        <div className="max-w-tight">
          <div className="kicker mb-2">{kicker}</div>
          <h1 className="text-3xl mb-8">{title}</h1>
          {children}
        </div>
      </section>
    </main>
  );
}
